<div class="dialog-stretch">

  <div class="d-flex justify-content-between pt-2"
    mat-dialog-title>
    <h2 class="mb-0 mat-headline-6  w-100 d-flex align-items-center">
      {{'FOLDER.MOVE_ITEMS' | translate}}
    </h2>
    <button mat-icon-button
      (click)="onClose()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <mat-dialog-content class="py-2">
    <form [formGroup]="form"
      (submit)="onSave()">
      <mat-form-field appearance="outline"
        class="w-100">
        <mat-label>{{'COMMON.LABEL.FOLDER' | translate}}</mat-label>
        <input type="text"
          matInput
          formControlName="folder"
          [matAutocomplete]="auto">
        <mat-autocomplete #auto="matAutocomplete"
          [displayWith]="displayFn"
          (optionSelected)="onSelectFolder($event)">
          @for (folder of filteredFolders; track folder) {
            <mat-option
              [value]="folder">
              ID:{{folder.id}} - {{folder.name | translate}}
            </mat-option>
          }
        </mat-autocomplete>
      </mat-form-field>
    </form>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-flat-button
      class="text-uppercase"
      (click)="onClose()">
      {{ 'BITF.LABEL.CANCEL' | translate }}
    </button>
    <button mat-flat-button
      class="text-uppercase"
      color="primary"
      [disabled]="!form.valid || !this.selectedFolder"
      (click)="onSave()">
      {{ 'COMMON.LABEL.CONFIRM' | translate }}
    </button>
  </mat-dialog-actions>
</div>